import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { CheckCircleIcon } from '@heroicons/react/solid'
import AnimateHeight from 'react-animate-height'

const CardStep = props => {
    const {
        title,
        subtitle,
        ready,
        content,
        onCardClick,
        active,
        onStepReady,
        onStepIsNotReady,
        actionsHeader,
    } = props

    // for refactor , tailwind not allow in this version the border-side-color
    const borderColor = ready
        ? 'border-colorsStatusBadges-completed-text'
        : active
        ? 'border-black'
        : 'border-grayLines'

    const renderContent = () => {
        return content && content
    }

    const renderActionsHeader = () => {
        return (
            actionsHeader &&
            active && (
                <div className="flex w-full flex-grow h-full items-center justify-end">
                    {actionsHeader({ onStepReady, onStepIsNotReady })}
                </div>
            )
        )
    }

    return (
        <AnimateHeight
            className="w-full my-3"
            id="step-panel"
            duration={500}
            contentClassName={clsx(
                `flex flex-row items-center justify-center border-l-2 border-solid`,
                borderColor,
            )}
            height={active ? 'auto' : 78}
        >
            <div
                className={clsx(
                    'bg-white w-full h-auto flex flex-col items-start justify-start border border-lineGray rounded-tr-3xl rounded-br-3xl border-l-2 ',
                )}
            >
                <div
                    onClick={onCardClick}
                    className={clsx(
                        'w-full h-auto px-6 py-4 flex flex-row items-center justify-between cursor-pointer',
                        active && 'border-b border-grayLines',
                    )}
                >
                    <div className="w-full h-auto flex flex-col items-start justify-start">
                        <p className="font-medium text-black70 text-base">
                            {title}
                        </p>
                        {!active && (
                            <p className="font-medium text-sm text-textDarkGray">
                                {subtitle}
                            </p>
                        )}
                    </div>

                    {ready && !active ? (
                        <CheckCircleIcon className="w-6 h-6 text-green-700" />
                    ) : (
                        renderActionsHeader()
                    )}
                </div>
                {active && (
                    <div className="w-full h-auto p-4 flex flex-col items-start justify-start">
                        {renderContent()}
                    </div>
                )}
            </div>
        </AnimateHeight>
    )
}

CardStep.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    ready: PropTypes.bool,
    content: PropTypes.func,
    active: PropTypes.bool,
    onCardClick: PropTypes.func,
    onStepReady: PropTypes.func,
    onStepIsNotReady: PropTypes.func,
    actionsHeader: PropTypes.func,
}

export default CardStep
